import React from 'react'
import type { Icon } from 'shared/utils'

const CircleClose = (props: Icon) => {
    const {
        color = '#D8D8D8',
        background = '#BB1E32',
        size = 40,
        className = 'circle-close'
    } = props

    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 40 40"
            preserveAspectRatio="none">
            <g fill="none" fillRule="evenodd">
                <circle cx={20} cy={20} r={20} fill={background} />
                <path
                    fill={color}
                    d="M21.763 20.29l4.39-4.388a1.04 1.04 0 1 0-1.474-1.473l-4.389 4.389-4.39-4.39a1.04 1.04 0 1 0-1.472 1.474l4.389 4.389-4.389 4.388a1.04 1.04 0 1 0 1.474 1.474l4.388-4.389 4.388 4.389a1.04 1.04 0 1 0 1.474-1.474l-4.389-4.388z"
                />
            </g>
        </svg>
    )
}

export { CircleClose }
